import { ValidatorPosition } from '../../position/validator-position';
export const config = {
    value: 'maxItems',
    position: [
        ValidatorPosition.form,
        ValidatorPosition.formDialog,
        ValidatorPosition.cnArraySubAreaCard,
    ],
};
